export default "__VITE_ASSET__C$nRjzY7__"